<div class="canvas-style">
    <div class="datepicker">
        <datepicker [(date)]="startDate" class="date"></datepicker>
        <datepicker [(date)]="finDate" class="date"></datepicker>
        <button class="btn btn-sm btn-primary" (click)="staticRdv()">Ok</button>
    </div>

    <canvas #rdvPeriodeCanvas width="400"></canvas>
</div>